namespace $.$$ {

	$mol_style_define( $shm_hitalama_agent_tool_card, {

		flexDirection: 'column',
		gap: $mol_gap.text,
		padding: {
			left: $mol_gap.block,
			right: $mol_gap.block,
			top: $mol_gap.text,
			bottom: $mol_gap.block,
		},
		background: {
			color: $mol_theme.card,
		},
		border: {
			width: '1px',
			style: 'solid',
			color: $mol_theme.line,
			radius: $mol_gap.round,
		},

		Head: {
			gap: $mol_gap.text,
			align: {
				items: 'center',
			},
		},

		Title: {
			flex: {
				grow: 1,
				shrink: 1,
				basis: 0,
			},
			minWidth: 0,
			color: $mol_theme.text,
		},

		Status: {
			color: $mol_theme.shade,
			font: {
				size: '0.8rem',
			},
		},

		Copy: {
			flex: {
				shrink: 0,
			},
		},

		Input: {
			margin: '-0.75rem',
		},

		Options: {
			flex: {
				wrap: 'wrap',
			},
			gap: $mol_gap.text,
		},

		Content: {
			margin: '-0.75rem',
		},

		Error: {
			margin: '-0.75rem',
			color: $shm_theme.error,
		},

		'[status="running"]': {
			border: {
				color: $shm_theme.active,
			},
		},

		'[status="error"]': {
			border: {
				color: $shm_theme.error,
			},
		},

		'[status="completed"]': {
			border: {
				color: $shm_theme.success,
			},
		},

		'[status="done"]': {
			border: {
				color: $shm_theme.success,
			},
		},

		'[status="success"]': {
			border: {
				color: $shm_theme.success,
			},
		},

	} )

}
